import React from 'react';
import PropTypes from 'prop-types';
import {InfoTitle, InfoSubtitle} from '../atoms';

const LabelledInfo = ({title, subtitle, style}) => (
  <div style={style}>
    <InfoTitle style={{marginBottom: 6}}>
      {title}
    </InfoTitle>
    <InfoSubtitle>
      {subtitle}
    </InfoSubtitle>
  </div>
);

LabelledInfo.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  style: PropTypes.object
};

export default LabelledInfo;
